import { decode } from "jsonwebtoken";
import CryptoJS from 'crypto-js'
export class StorageKeys {
  static TOKEN = "access_token";
  static LOCAL = "localStorage";
  static SESSION = "sessionStorage";
  static NOME = 'sessionName'
}

export class ClientSession {

  static get user() {
    const userAuth = ClientSession.userTokenPayload
    const existisUser = getDataFromStorage(StorageKeys.SESSION, userAuth.userId);

    if (existisUser) return buildUser(existisUser)
    
    return {}
  }

  static set user(data) {
    const user = buildUser(data)
    saveDataToStorage(StorageKeys.SESSION, user.userId, user)
  }

  /**
   * @returns {userTokenPayloadType}
   */
  static get userTokenPayload() {
   const payload =  decode(getDataFromStorage(StorageKeys.LOCAL, StorageKeys.TOKEN));
   return Object.freeze(payload)
  }


  static set userToken(token) {
    saveDataToStorage(StorageKeys.LOCAL, StorageKeys.TOKEN, token)
  }

  /**
   * @returns {string}
   */
  static get userToken() {
    return getDataFromStorage(StorageKeys.LOCAL, StorageKeys.TOKEN)
  }

  static logout() {
    sessionStorage.removeItem(ClientSession.userTokenPayload.userId)
    localStorage.removeItem(StorageKeys.TOKEN)
  }
}

const userType = Object.freeze({
  // "email": "string",
  // "password": "string",
  "username": "string",
  "rememberToken": false,
  "userId": "uuid",
  "profileId": "uuid"
})

const userTokenPayloadType = Object.freeze({
  userId: "uuid"
})

/**
 * 
 * @param {userType} user 
 * @returns {userType}
 */
function buildUser(user) {
  let obj = {}

  for (const key of Object.keys(userType)) {
    obj[key] = user[key]
  }
  obj.userId = user.id;
  return Object.freeze(obj)
}

function getDataFromStorage(
  type = StorageKeys.SESSION,
  key = StorageKeys.TOKEN
) {
  let data;
  if (type === StorageKeys.LOCAL) data = localStorage.getItem(key);
  else if (type === StorageKeys.SESSION) data = sessionStorage.getItem(key);
  else throw new TypeError(`${type} invalid option`);

  return JSON.parse(data);
}

function saveDataToStorage(
  type = StorageKeys.SESSION,
  key = StorageKeys.TOKEN,
  data
) {
  if (type === StorageKeys.LOCAL) localStorage.setItem(key, JSON.stringify(data));
  else if (type === StorageKeys.SESSION) sessionStorage.setItem(key, JSON.stringify(data));
  else throw new TypeError(`${type} invalid option`);
}

// function encrypt(data) {
//   return CryptoJS.AES.encrypt(JSON.stringify(data), 'secret key 123').toString();
// }

// function decrypt(cipher) {
//   var bytes  = CryptoJS.AES.decrypt(cipher, 'secret key 123');
//   return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
// }

